"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAmountWithDecimalDigits = getAmountWithDecimalDigits;
exports.policyTypeName = policyTypeName;
exports.capitalize = capitalize;
exports.getAmountToDisplay = getAmountToDisplay;
exports.formatAmount = formatAmount;
exports.getCoverTierWording = getCoverTierWording;
exports.getCoverTierChangeWording = getCoverTierChangeWording;
exports.formatDate = formatDate;
exports.isAnnualProduct = isAnnualProduct;
var services_1 = require("@falcon/services");
var moment = require("moment-timezone");
function getAmountWithDecimalDigits(amount) {
    var fixedAmount = 1 * amount;
    return new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(fixedAmount);
}
function policyTypeName(type) {
    switch (type) {
        case "NEW":
            return "New Business";
        case "MTA":
            return "Mid-Term Adjustment";
        case "RENEWAL":
            return "Renewal";
        case "MTC":
            return "Mid-Term Cancellation";
        case "REINSTATE":
            return "Reinstate";
        default:
            return "";
    }
}
function capitalize(text) {
    return text.toLowerCase().split(' ').map(function (s) { return s.charAt(0).toUpperCase() + s.substring(1).toLowerCase(); }).join(' ');
}
function getAmountToDisplay(amount) {
    if ((amount % 1) === 0) {
        return formatAmount(amount);
    }
    else {
        return getAmountWithDecimalDigits(amount);
    }
}
function formatAmount(amount) {
    var sign = amount < 0 ? '-' : '';
    var value = Math.abs(amount);
    return "".concat(sign, "\u00A3").concat(new Intl.NumberFormat('en-GB').format(value));
}
function getCoverTierWording(coverTierEnumName) {
    switch (coverTierEnumName) {
        case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_1:
            return services_1.resourcesHelper.TIER_1;
        case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2:
            return services_1.resourcesHelper.TIER_2;
        case services_1.MOTOR_COVER_TIERS.MOTOR_TIER_3:
            return services_1.resourcesHelper.TIER_3;
        default:
            return "";
    }
}
function getCoverTierChangeWording(interaction) {
    var _a, _b, _c, _d;
    if ((_a = interaction.uistate) === null || _a === void 0 ? void 0 : _a.upgradeToAllianz) {
        return "Cover level upgrade to Allianz";
    }
    var newTier = getCoverTierWording(interaction.coverTier);
    var previousTier = getCoverTierWording((_b = interaction.uistate) === null || _b === void 0 ? void 0 : _b.previousCoverTier);
    var isDowngrade = ((_c = interaction.uistate) === null || _c === void 0 ? void 0 : _c.previousCoverTier) === services_1.MOTOR_COVER_TIERS.MOTOR_TIER_3 ||
        (interaction.coverTier === services_1.MOTOR_COVER_TIERS.MOTOR_TIER_1 && ((_d = interaction.uistate) === null || _d === void 0 ? void 0 : _d.previousCoverTier) === services_1.MOTOR_COVER_TIERS.MOTOR_TIER_2);
    if (!previousTier || newTier === previousTier) {
        return "";
    }
    return "Cover level ".concat(isDowngrade ? "downgrade" : "upgrade", " from ").concat(previousTier, " to ").concat(newTier);
}
function formatDate(date) {
    return moment(date).utc().format("DD/MM/YYYY HH:mm");
}
function isAnnualProduct(product) {
    return product === services_1.PRODUCT_WOLF_MOTOR || product === services_1.PRODUCT_ANNUAL_HOME;
}
//# sourceMappingURL=commonFunctions.js.map